import { Link, createFileRoute } from "@tanstack/react-router";

import MySkills from "@/components/MySkills";
import { AppHeader } from "@/components/app-header";
import { RequireAuth } from "@/components/route-guards";
import { useAuth } from "@/lib/auth";
import { signOut } from "@/lib/platform-fetch";

/**
 * `/settings/skills` -- the caller's own skills, plus which granted ones they have muted.
 *
 * Guarded by `RequireAuth` only. There is deliberately no `RequireCanAuthorSkills`: the page is
 * useful to anyone who has been *granted* skills even if they may not author any, since the
 * mute controls live here too. Creating is what needs the capability, and the routes behind the
 * create button enforce it -- the same affordance/boundary split `route-guards.tsx` documents.
 */
export const Route = createFileRoute("/settings/skills")({
  component: SkillsRoute,
});

function SkillsRoute() {
  return (
    <RequireAuth>
      <SkillsPage />
    </RequireAuth>
  );
}

function SkillsPage() {
  const { user, hasAdminAccess, canAuthorSkills, skillsEnabled } = useAuth();

  return (
    <main className="flex min-h-dvh flex-col">
      <AppHeader
        left={<Link to="/">&larr; Back to chat</Link>}
        userLabel={user?.email ?? user?.name ?? "unknown"}
        hasAdminAccess={hasAdminAccess}
        skillsEnabled={skillsEnabled}
        signOutAction={signOut}
      />
      <MySkills canAuthor={canAuthorSkills} />
    </main>
  );
}
